function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.70701 2.293C3.51841 2.11084 3.26581 2.01004 3.00361 2.01232C2.74141 2.0146 2.4906 2.11977 2.30519 2.30518C2.11978 2.49058 2.01461 2.7414 2.01234 3.00359C2.01006 3.26579 2.11085 3.51839 2.29301 3.707L16.293 17.707C16.4816 17.8892 16.7342 17.9899 16.9964 17.9877C17.2586 17.9854 17.5094 17.8802 17.6948 17.6948C17.8802 17.5094 17.9854 17.2586 17.9877 16.9964C17.99 16.7342 17.8892 16.4816 17.707 16.293L16.234 14.82C17.7915 13.5781 18.9433 11.8999 19.542 10C18.268 5.943 14.478 3 10 3C8.43244 2.99787 6.88651 3.36585 5.48801 4.074L3.70801 2.293H3.70701ZM7.96801 6.553L9.48201 8.068C9.8211 7.97795 10.1779 7.97854 10.5167 8.06973C10.8555 8.16091 11.1644 8.33948 11.4124 8.58756C11.6605 8.83564 11.8391 9.14454 11.9303 9.48333C12.0215 9.82211 12.0221 10.1789 11.932 10.518L13.446 12.032C13.897 11.268 14.0812 10.3758 13.9697 9.49567C13.8581 8.61555 13.4571 7.79749 12.8298 7.17017C12.2025 6.54286 11.3845 6.14189 10.5043 6.03034C9.62422 5.9188 8.73199 6.10301 7.96801 6.554V6.553Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.454 16.697L9.75001 13.992C8.77769 13.9311 7.86103 13.5174 7.17206 12.8286C6.4831 12.1398 6.06918 11.2233 6.00801 10.251L2.33501 6.578C1.49022 7.58402 0.852357 8.74692 0.458008 10C1.73201 14.057 5.52301 17 10 17C10.847 17 11.669 16.895 12.454 16.697Z",
  fill: "currentColor"
});

function SvgEyeOffSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOffSolid);
export default __webpack_public_path__ + "static/media/eye-off-solid.e974b975.svg";
export { ForwardRef as ReactComponent };